// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3k4x3","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3tTnQ"};